const GA_ID_M4U = process.env.REACT_APP_GA_ID_M4U;

export const analyticsM4U = {
  INITIALIZE_GA: {
    event_type: "create",
    GA_ID_M4U,
    build: () => ({ name: "M4U" }),
  },
  SMS_REQUEST: {
    event_type: "event",
    event_action: "clique:login",
    build: () => {
      return {
        send_to: ["M4U"],
        event_category: "claro:recarga-login",
        event_label: "digitou-numero",
      };
    },
  },
  LOGIN_ERROR: {
    event_type: "event",
    event_action: "clique:codigo-confirmacao",
    build: () => {
      return {
        send_to: ["M4U"],
        event_category: "claro:recarga-login",
        event_label: "tentativa:erro",
      };
    },
  },
  LOGIN_SUCCESS: {
    event_type: "event",
    event_action: "clique:codigo-confirmacao",
    build: () => {
      return {
        send_to: ["M4U"],
        event_category: "claro:recarga-login",
        event_label: "tentativa:sucesso",
      };
    },
  },
  ENCRYPTED_LOGIN_REGISTER: {
    event_type: "event",
    event_action: "clique:login-externo",
    build: payload => {
      const { channel, status } = payload;
      const channelCase = channel ? channel.toLowerCase() : "unknown";
      return {
        send_to: ["M4U"],
        event_category: `claro:${channelCase}`,
        event_label: `tentativa:${status}`,
      };
    },
  },
  SELECTED_RECHARGE_VALUE: {
    event_type: "event",
    event_action: "clique:selecionar-valor",
    build: payload => {
      const { value, isScheduled } = payload;
      return {
        send_to: ["M4U"],
        event_category: isScheduled ? "claro:recarga-programada" : "claro:recarga-avulsa",
        event_label: isScheduled
          ? `recarga-programada-${value / 100}`
          : `recarga-avulsa-${value / 100}`,
      };
    },
  },
  SELECT_RECHARGE_BOX: {
    event_type: "event",
    event_action: "clique:selecionar-numero",
    build: payload => {
      const { rechargeOwner, isScheduled } = payload;
      return {
        send_to: ["M4U"],
        event_category: isScheduled ? "claro:recarga-programada" : "claro:recarga-avulsa",
        event_label: rechargeOwner,
      };
    },
  },
  SELECTED_PAYMENT_FORM: {
    event_type: "event",
    event_action: "inserir:forma_de_pagamento",
    build: payload => {
      const { paymentForm, isScheduled } = payload;
      return {
        send_to: ["M4U"],
        event_category: isScheduled
          ? `claro:recarga-programada:add-${paymentForm}`
          : `claro:recarga-avulsa:add-${paymentForm}`,
        event_label: "dados-forma_de_pagamento",
      };
    },
  },
  SELECTED_INSTALLMENT: {
    event_type: "event",
    event_action: "inserir:parcelas",
    build: payload => {
      const { installments, rechargeValue, isScheduled } = payload;
      return {
        send_to: ["M4U"],
        event_category: isScheduled
          ? `claro:recarga-programada:valor-${rechargeValue}-parcelas-${installments}`
          : `claro:recarga-avulsa:valor-${rechargeValue}-parcelas-${installments}`,
        event_label: "dados-parcelamento",
      };
    },
  },
  CHECK_RECHARGE_TYPE: {
    event_type: "event",
    event_action: "inserir:cartao",
    build: payload => {
      const { isScheduled } = payload;

      return {
        send_to: ["M4U"],
        event_category: isScheduled
          ? `claro:recarga-programada:add-cartao`
          : `claro:recarga-avulsa:add-cartao`,
        event_label: "cvv-cartao",
      };
    },
  },
  SELECT_RECHARGE_FREQUENCY: {
    event_type: "event",
    event_action: "clique:selecionar-periodo",
    build: payload => {
      const { frequency } = payload;
      const translateFrequency = {
        MONTHLY: "mensal",
        BIWEEKLY: "quinzenal",
        WEEKLY: "semanal",
      };

      return {
        send_to: ["M4U"],
        event_category: "claro:recarga-programada",
        event_label: translateFrequency[frequency],
      };
    },
  },
  CREDIT_CARD_SELECTION: {
    event_type: "event",
    event_action: "selecao:cartao",
    build: payload => {
      const { isScheduled } = payload;

      return {
        send_to: ["M4U"],
        event_category: isScheduled ? "claro:recarga-programada" : "claro:recarga-avulsa",
        event_label: "cartao-selecionado",
      };
    },
  },
  CREATE_PAYPAL_ACCOUNT: {
    event_type: "event",
    event_action: "inserir:conta",
    build: () => {
      return {
        send_to: ["M4U"],
        event_category: "claro:paypal",
        event_label: "cadastro-paypal",
      };
    },
  },
  PROCESS_PAYPAL_AUTHORIZED: {
    event_type: "event",
    event_action: "sucesso:inserir:conta",
    build: () => {
      return {
        send_to: ["M4U"],
        event_category: "claro:paypal",
        event_label: "cadastro-paypal",
      };
    },
  },
  CREATE_PAYPAL_ACCOUNT_FAILURE: {
    event_type: "event",
    event_action: "erro:inserir:conta",
    build: () => {
      return {
        send_to: ["M4U"],
        event_category: "claro:paypal",
        event_label: "cadastro-paypal",
      };
    },
  },
  RECHARGES_SUCCESS: {
    event_type: "event",
    event_action: "tentativa:compra",
    build: payload => {
      const { paymentMethod } = payload;
      return {
        send_to: ["M4U"],
        event_category: "claro:recarga-avulsa:compra-recarga",
        event_label: `sucesso:${paymentMethod.type}`,
      };
    },
  },
  RECHARGES_ERROR: {
    event_type: "event",
    event_action: "tentativa:compra",
    build: () => {
      return {
        send_to: ["M4U"],
        event_category: "claro:recarga-avulsa:compra-recarga",
        event_label: "erro",
      };
    },
  },
  SCHEDULED_RECHARGES_SUCCESS: {
    event_type: "event",
    event_action: "tentativa:compra",
    build: () => {
      return {
        send_to: ["M4U"],
        event_category: "claro:recarga-programada:compra-recarga",
        event_label: "sucesso",
      };
    },
  },
  SCHEDULED_RECHARGES_ERROR: {
    event_type: "event",
    event_action: "tentativa:compra",
    build: () => {
      return {
        send_to: ["M4U"],
        event_category: "claro:recarga-programada:compra-recarga",
        event_label: "erro",
      };
    },
  },
  SCHEDULED_RECHARGE_BUTTON_CLICK: {
    event_type: "event",
    event_action: "clique:programar",
    build: () => {
      return {
        send_to: ["M4U"],
        event_category: "claro:recarga-home",
        event_label: "recarga-programada",
      };
    },
  },
  SCHEDULED_RECHARGE_DAY_SELECTION: {
    event_type: "event",
    event_action: "clique:selecionar-dia",
    build: payload => {
      const { day } = payload;
      return {
        send_to: ["M4U"],
        event_category: "claro:recarga-programada",
        event_label: day,
      };
    },
  },
  LANDING_PAGE_VALUE: {
    event_type: "event",
    event_action: "clique:landing-select",
    build: payload => {
      const { value, category } = payload;
      return {
        send_to: ["M4U"],
        event_category: `claro:${category}`,
        event_label: `recarga-avulsa-${value}`,
      };
    },
  },
  PAGE_LOAD_PRIVATE_LABEL: {
    event_type: "event",
    event_action: "exibir:private-label",
    build: payload => {
      const { value } = payload;
      return {
        send_to: ["M4U"],
        event_category: `claro:recarga-avulsa:exibe-private`,
        event_label: `exibido:${value}`,
      };
    },
  },
  PAGE_SHOW_PRIVATE_LABEL: {
    event_type: "event",
    event_action: "clique:selecionar:private-label",
    build: payload => {
      const { value } = payload;
      return {
        send_to: ["M4U"],
        event_category: `claro:recarga-avulsa:exibe-private`,
        event_label: `selecionado:${value}`,
      };
    },
  },
};

export const analyticsM4UMiddleware = store => next => action => {
  try {
    if (window.location.pathname.search("no-credit") === -1) {
      const { type, payload } = action;
      if (analyticsM4U[type]) {
        window.gtag(
          analyticsM4U[type].event_type,
          analyticsM4U[type].event_action,
          analyticsM4U[type].build(payload, store)
        );
      }
    }
  } catch (e) {
    console.log("channel doesn't have GA support");
  }

  next(action);
};

export default analyticsM4UMiddleware;
